var map = {
	"./locales/modules/zh-CN/footer.js": "974c",
	"./locales/modules/zh-CN/guide.js": "abb6",
	"./locales/modules/zh-CN/index.js": "12dd",
	"./locales/modules/zh-CN/system.js": "9981",
	"./locales/modules/zh-CN/user.js": "e93b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc5f";